<!--
/**
* @name: List.vue
* @description: 门店陈列活动-列表页
* @author: 杨波
* @create: 2022/05/19 09:40:37
* @update: 2020/05/19 09:40:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <div :class="[css.inputW, css.fontStyle]">活动名称：{{ statisticsPara.activityName }}</div>
      </y-query-item>
      <y-query-item>
        <div :class="[css.inputW, css.fontStyle]">待审核：{{ statisticsPara.waitNumber }}</div>
      </y-query-item>
      <y-query-item>
        <div :class="[css.inputW, css.fontStyle]">审核通过：{{ statisticsPara.passedNumber }}</div>
      </y-query-item>
      <y-query-item>
        <div :class="[css.fontStyle]">审核拒绝：{{ statisticsPara.refuseNumber }}</div>
      </y-query-item>
      <y-query-item slot="right"> <k-button type="primary" @click="onExport">导出</k-button> </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入门店编码" block clearable v-model="para.shopCode"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入门店名称" block clearable v-model="para.shopName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择状态" clearable block v-model="para.auditStatus">
          <k-option v-for="item in auditStatusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <k-dropdown :title="title()" layerMinWidthEqual>
          <k-option @click="onBatchAudit(1)">审核通过</k-option>
          <k-option @click="onBatchAudit(2)">审核拒绝</k-option>
        </k-dropdown>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <!-- 审核拒绝确认弹窗区域 start -->
    <k-popup bind="v-if" okText="确认" title="审核拒绝" :show.sync="isShowPopup" @after-ok="onSave">
      <div style="width: 650px;">
        <y-form titleAlign="right" titleWidth="60px" contentWidth="400px">
          <y-form-item title="拒绝原因:" required align="top">
            <k-input tag="textarea" :class="css.textarea" placeholder="请输入拒绝原因，最多输入50个字" maxlength="50" block v-model="refuseReason" clearable></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 审核拒绝确认弹窗区域 end -->
    <k-table
      :data="dataList"
      checkboxKey="id"
      :selectedRows.sync="selectedRows"
      :selectedKeys.sync="selectedKeys"
      hasCheckbox
      :height="$root.tableHeightXX"
      :rightFixedNumber="1"
      :columns="initColumns()"
    ></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import {
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_EXPORT,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_PAGE_LIST,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_STATISTICS,
} from "@/assets/modules/apiList";
const initPara = () => ({
  shopCode: "", //门店编码
  shopName: "", //门店名称
  auditStatus: "", //审核状态
  displayActivityId: "", //活动ID
  pageCurrent: 1,
  pageSize: 15,
});
const initStatisticsPara = () => ({
  activityName: "", //陈列活动名称
  waitNumber: "0", //待审核数量
  passedNumber: "0", //审核通过数量
  refuseNumber: "0", //审核拒绝数量
  shopNumber: "0", //提交门店数量
  id: "",
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      id: "", //申请记录ID
      statisticsPara: initStatisticsPara(),
      refuseReason: "", //拒绝原因
      isShowPopup: false,
      displayActivityId: "",
      selectedRows: [],
      selectedKeys: [],
      dataList: [],
      auditStatusList: [
        { value: "wait", label: "待审核" },
        { value: "passed", label: "审核通过" },
        { value: "refused", label: "审核拒绝" },
      ],
      total: 0,
      isBatchHandle: false,
    };
  },
  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    title() {
      return (
        <k-button type="primary">
          批量审核
          <k-icon name="k-icon-arrow-down" />
        </k-button>
      );
    },

    /** 初始化表格 */
    initColumns() {
      let tableItem = [
        { name: "门店编码", style: this.tableStyle(80), customRender: (row) => <div>{row.shopCode ? row.shopCode : "——"}</div> },
        { name: "门店名称", style: this.tableStyle(150), customRender: (row) => <div>{row.shopName ? row.shopName : "——"}</div> },
        {
          name: "审核状态",
          style: {
            width: 80,
            "text-align": "center",
            "white-space": "normal",
            "word-break": "break-all",
            overflow: "visible",
          },
          customRender: (row) => (
            <div>
              {row.auditStatus === "refused" && <tool-tip value={row.auditStatusName} tipValue={row.refuseReason} direction="left" width="220"></tool-tip>}
              {row.auditStatus !== "refused" && row.auditStatusName}
            </div>
          ),
        },
        { name: "提交时间", style: this.tableStyle(100), customRender: (row) => <div>{row.submitTime ? row.submitTime : "——"}</div> },
        { name: "审核时间", style: this.tableStyle(100), customRender: (row) => <div>{row.auditTime ? row.auditTime : "——"}</div> },
        {
          name: "操作",
          style: this.tableStyle(100),
          customRender: (row) => (
            <div>
              {row.auditStatus === "wait" && (
                <a href="javascript:;" onclick={() => this.handleLinkToAuditPass(row)}>
                  审核通过&#12288;
                </a>
              )}
              {row.auditStatus === "wait" && (
                <a href="javascript:;" onclick={() => this.handleLinkToRefusePopup(row)}>
                  审核拒绝&#12288;
                </a>
              )}
              <a href="javascript:;" onclick={() => this.handleLinkToDetail(row)}>
                查看
              </a>
            </div>
          ),
        },
      ];
      return tableItem;
    },

    onBatchAudit(type) {
      if (this.selectedKeys.length === 0) {
        return this.$root.tip("请选择需要审核的申请记录", "error");
      }
      switch (type) {
        case 1:
          this.$dialog({
            title: "提示",
            content: "是否确认批量审核通过选中的申请记录？",
            ok: () => {
              this.isLoading = true;
              this.$fetch({
                api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
                para: { ids: this.selectedKeys, auditStatus: "passed" },
              })
                .then(() => {
                  this.isLoading = false;
                  this.$root.tip("操作成功", "success");
                  this.getExhibitList();
                })
                .catch(() => {
                  this.isLoading = false;
                });
            },
          });
          break;

        default:
          this.isBatchHandle = true;
          this.refuseReason = "";
          this.isShowPopup = true;
          break;
      }
    },

    /** 门店陈列活动审核详情页面 */
    handleLinkToDetail(row) {
      this.$controller.open({
        name: "applyStoreDetail",
        query: {
          refresh: new Date() - 0,
          id: row.id ? row.id : "",
        },
        title: "审核记录-详情",
      });
    },

    handleLinkToRefusePopup(row) {
      this.refuseReason = "";
      this.isBatchHandle = false;
      this.id = row.id;
      this.isShowPopup = true;
    },

    /** 审核通过操作 */
    handleLinkToAuditPass(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核通过当前门店陈列活动？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
            para: { ids: [row.id], auditStatus: "passed" },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.selectedRows = [];
              this.selectedKeys = [];
              this.getExhibitList();
              this.getStatistics(this.para.displayActivityId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 审核拒绝确认操作 */
    onSave() {
      if (!this.refuseReason) {
        return this.$root.tip("请输入拒绝原因", "error");
      }
      this.$dialog({
        title: "提示",
        content: `${this.isBatchHandle ? "是否确认批量审核拒绝选中的申请记录？" : "是否确认审核拒绝当前门店陈列活动？"}`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_AUDIT,
            para: { ids: this.isBatchHandle ? this.selectedKeys : [this.id], auditStatus: "refused", refuseReason: this.refuseReason },
          })
            .then(() => {
              this.isLoading = false;
              this.$root.tip("操作成功", "success");
              this.isShowPopup = false;
              this.selectedRows = [];
              this.selectedKeys = [];
              this.getExhibitList();
              this.getStatistics(this.para.displayActivityId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 刷新门店陈列活动申请列表 */
    getExhibitList() {
      let { para } = this;
      this.isLoading = true;
      this.$fetch({ api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_PAGE_LIST, para })
        .then((res) => {
          this.dataList = res.pageList || [];
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 获取陈列活动申请统计信息 */
    getStatistics(id) {
      this.$fetch({ api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_STATISTICS, para: { id: id } }).then((res) => {
        this.statisticsPara = { ...this.statisticsPara, ...res };
      });
    },

    /** 条件查询门店陈列活动申请列表 */
    onSearch() {
      this.para.pageCurrent = 1;
      this.getExhibitList();
      this.getStatistics(this.para.displayActivityId);
    },

    /** 清空门店陈列活动申请列表查询条件 */
    onReset() {
      this.para = initPara();
      this.para.displayActivityId = this.displayActivityId;
      this.getExhibitList();
      this.getStatistics(this.para.displayActivityId);
    },

    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getExhibitList();
    },

    onExport() {
      this.isLoading = true;
      let para = JSON.parse(JSON.stringify(this.para));
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_APPLY_EXPORT,
        para,
        isBlob: true,
        filename: "门店陈列活动申请记录",
      })
        .then((res) => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  async created() {
    const { id } = this.$route.query;
    this.para = initPara();
    this.statisticsPara = initStatisticsPara();
    this.displayActivityId = id;
    this.para.displayActivityId = id;
    this.getStatistics(id);
    this.getExhibitList();
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.para = initPara();
    this.statisticsPara = initStatisticsPara();
    this.displayActivityId = id;
    this.para.displayActivityId = id;
    this.getStatistics(id);
    this.getExhibitList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 230px !important;
}
.fontStyle {
  font-size: 13px;
  font-weight: bold;
}
.textarea {
  width: 400px !important;
  height: 150px;
  & :global(.k-textarea) {
    height: 150px !important;
    resize: none;
  }
}
</style>
